import { create } from 'zustand';

export const useRoleStore = create((set, get) => ({
  roles: {},       // { serverId: [role] }
  loading: false,

  fetchRoles: async (serverId) => {
    if (!serverId || serverId.startsWith('demo-')) {
      set(s => ({ roles: { ...s.roles, [serverId]: [
        { id: 'r1', name: 'Owner',     color: '#f59e0b', position: 100, hoist: true,  permissions: { ADMINISTRATOR: true } },
        { id: 'r2', name: 'Admin',     color: '#ef4444', position: 80,  hoist: true,  permissions: { KICK_MEMBERS: true, BAN_MEMBERS: true, MANAGE_CHANNELS: true } },
        { id: 'r3', name: 'Moderator', color: '#10b981', position: 60,  hoist: true,  permissions: { KICK_MEMBERS: true } },
        { id: 'r4', name: 'Member',    color: '#6366f1', position: 10,  hoist: false, permissions: {} },
        { id: 'r5', name: '@everyone', color: '#6b7280', position: 0,   hoist: false, permissions: {}, isEveryone: true },
      ] } }));
      return;
    }
    set({ loading: true });
    try {
      const res  = await fetch(`/api/servers/${serverId}/roles`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('auth_token')}` },
      });
      const data = await res.json();
      set(s => ({ roles: { ...s.roles, [serverId]: data.roles || [] }, loading: false }));
    } catch {
      set({ loading: false });
    }
  },

  createRole: async (serverId, payload) => {
    const res  = await fetch(`/api/servers/${serverId}/roles`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('auth_token')}` },
      body: JSON.stringify(payload),
    });
    const data = await res.json();
    if (data.success) set(s => ({ roles: { ...s.roles, [serverId]: [...(s.roles[serverId] || []).filter(r => !r.isEveryone), data.role, (s.roles[serverId] || []).find(r => r.isEveryone)].filter(Boolean) } }));
    return data.role;
  },

  updateRole: async (serverId, roleId, payload) => {
    if (!serverId.startsWith('demo-')) {
      await fetch(`/api/servers/${serverId}/roles/${roleId}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('auth_token')}` },
        body: JSON.stringify(payload),
      });
    }
    set(s => ({
      roles: { ...s.roles, [serverId]: (s.roles[serverId] || []).map(r => r.id === roleId ? { ...r, ...payload, permissions: { ...r.permissions, ...payload.permissions } } : r) },
    }));
  },

  deleteRole: async (serverId, roleId) => {
    if (!serverId.startsWith('demo-')) {
      await fetch(`/api/servers/${serverId}/roles/${roleId}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${localStorage.getItem('auth_token')}` },
      });
    }
    set(s => ({ roles: { ...s.roles, [serverId]: (s.roles[serverId] || []).filter(r => r.id !== roleId) } }));
  },

  getServerRoles: (serverId) => get().roles[serverId] || [],
}));
